module.exports = __webpack_public_path__ + "img/temorarily-unavailable.f20d5979.png";